document.addEventListener("turbolinks:load", () => {
  const dropdowns = document.querySelectorAll(".dropdown");
  [].forEach.call(dropdowns, (dropdown) => {
    dropdown.addEventListener("click", (e) => {
      e.stopPropagation();
      dropdown.classList.toggle("is-active");
    });
  });
});